import React from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import Input from '../Input';

const DragHandle = SortableHandle(props => (
    <div className="drag-point">
        <i className="fas fa-sort"></i>
    </div>
));

const Sortable = SortableElement(props => {
    return (
        <div className="sortable-item col-6">
            <div className="d-flex">
                <div>
                    <DragHandle {...props} />
                    <div className="delete-point" index={props.itemIndex} onClick={props.deleteButtonHandler}>
                        <i className="far fa-trash-alt"></i>
                    </div>
                </div>
                <div className="col">
                    <div className="card my-2 p-2">
                        <div className="form-group">
                            <label>Item</label>
                            <Input name={`elements.${props.itemIndex}.title`} value={props.element.content || ''}
                                   onChange={props.onChange}/>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card my-2 p-2">
                        <div className="form-group">
                            <label>Title</label>
                            <Input name={`elements.${props.itemIndex}.value`} value={props.element.value || ''}
                                   onChange={props.onChange}/>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card my-2 p-2">
                        <div className="form-group">
                            <label>Item</label>
                            <Input name={`elements.${props.itemIndex}.content`} value={props.element.content || ''}
                                   onChange={props.onChange}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
})

export default Sortable;
